import { useIntl, getCurrentLocale } from "@leagueplatform/locales";
import APPLE_EN from "assets/apple-store/app-store-en.png";
import APPLE_ES from "assets/apple-store/app-store-es.png";
import APPLE_ZH from "assets/apple-store/app-store-zh.png";
import { EXTERNAL_URLS } from "common/urls";
import { StoreLink } from "./store-link.component";

const IMAGES: Record<string, string> = {
  es: APPLE_ES,
  zh: APPLE_ZH,
  en: APPLE_EN,
};

export const AppleStoreLink = () => {
  const { formatMessage } = useIntl();
  const locale = getCurrentLocale();

  return (
    <StoreLink
      href={EXTERNAL_URLS.APPLE_STORE_APP}
      src={IMAGES[locale] ?? APPLE_EN}
      alt={formatMessage({ id: "STR_DOWNLOAD_APP_STORE" })}
      css={{ width: "auto" }}
    />
  );
};
